// // src/PageRoutes.js
// import React from 'react';
// import { Routes, Route, Navigate } from 'react-router-dom';
// import { Box } from '@mui/material';

// // Import your pages/components (you'll create these later)
// import HomePage from '../Homepage/Homepage';
// import Contactus from '../Contactus/Contactus';
// import About from '../About/About';
// import Services from '../services/Services';
// import PageNotFound from '../PageNotFound/PageNotFound';
// import Header from '../../Components/Common/Header';
// import Footer from '../../Components/Common/Footer';
// import Login from '../Login/Login';
// import Dashboard from '../../Dashboard/Dashboard';

// // Layout component for consistent styling
// const Layout = ({ children }) => {
//   return (
    
//     <Box sx={{ minHeight: '100vh' }}>
//       {/* You can add Header/Navigation here later */}
//       {children}
//       {/* You can add Footer here later */}
//     </Box>
//   );
// };

// const PageRoutes = () => {
//   return (
//     <Layout>
//       <Header/>
//       <Routes>
//         {/* Home Route */}
//         <Route path="/" element={<HomePage />} />
        
//         {/* Contact Route */}
//         <Route path="/contact" element={<Contactus />} />
        
//         {/* About Route */}
//         <Route path="/about" element={<About />} />
        
//         {/* Services Route */}
//         <Route path="/services" element={<Services />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/dashboard" element={<Dashboard />} />
        
//         {/* Redirect unknown routes to home */}
//         <Route path="/home" element={<Navigate to="/" replace />} />
        
//         {/* 404 Not Found Route */}
//         <Route path="*" element={<PageNotFound />} />
//       </Routes>
//       <Footer/>
//     </Layout>
//   );
// };

// export default PageRoutes;


import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

// Import your pages/components
import HomePage from '../Homepage/Homepage';
import Contactus from '../Contactus/Contactus';
import About from '../About/About';
import Services from '../services/Services';
import PageNotFound from '../PageNotFound/PageNotFound';
import Header from '../../Components/Common/Header';
import Footer from '../../Components/Common/Footer';
import Login from '../Login/Login';
import Dashboard from '../../Dashboard/Dashboard'; // Iska naam Dashboard.jsx file se match hona chahiye

// --- Layout for pages with Header and Footer ---
// Yeh component Header aur Footer ko render karega, aur beech mein child routes ko render karne ke liye <Outlet /> ka istemal karega.
const MainLayout = () => {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Outlet /> 
      </Box>
      <Footer />
    </Box>
  );
};


const PageRoutes = () => {
  return (
    <Routes>
      {/* Routes that WILL have the Header and Footer */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact" element={<Contactus />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/home" element={<Navigate to="/" replace />} />
      </Route>

      {/* --- Routes that WILL NOT have the Header and Footer --- */}
      <Route path="/login" element={<Login />} />
      {/* Dashboard component ka apna layout hai, isliye ise alag rakha gaya hai */}
      <Route path="/dashboard" element={<Dashboard />} /> 
      
      {/* 404 Not Found Route */}
      {/* Aap ise MainLayout ke andar ya bahar rakh sakte hain, jaisa aapko theek lage */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default PageRoutes;

